module.exports = __webpack_public_path__ + "static/media/McKroket.8bee6de4.png";